class SessionGuardian {
  tokenKey = 'token';

  getToken() {
    return sessionStorage.getItem(this.tokenKey);
  }

  setToken(token: string) {
    sessionStorage.setItem(this.tokenKey, token);
  }

  isLogged() {
    return !!sessionStorage.getItem(this.tokenKey);
  }

  clear() {
    sessionStorage.removeItem(this.tokenKey);
  }
}

export default new SessionGuardian();
